import type { ConsumerInsurance } from "@/app/directories/kiosk/server-actions/pc-actions";
import type { InsuranceConnectorContext } from "./types";

/**
 * Map ConsumerInsurance array from the API into the machine context shape.
 * Uses priority field to distinguish primary (1) from secondary (2).
 */
export function mapConsumerInsurances(insurances: ConsumerInsurance[]): {
  primaryInsurance?: InsuranceConnectorContext["primaryInsurance"];
  secondaryInsurance?: InsuranceConnectorContext["secondaryInsurance"];
} {
  const primary = insurances.find((i) => i.priority === 1) || insurances[0];
  const secondary = insurances.find((i) => i.priority === 2);
  return {
    primaryInsurance: primary
      ? {
          payer: primary.payer,
          memberId: primary.memberId,
          insuredState: primary.state,
          insuredFirstName: primary.insuredFirstName,
          insuredLastName: primary.insuredLastName,
          planName: primary.planName,
        }
      : undefined,
    secondaryInsurance: secondary
      ? {
          payer: secondary.payer,
          memberId: secondary.memberId,
          insuredState: secondary.state,
          planName: secondary.planName,
        }
      : undefined,
  };
}
